
import React from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';

import metadata from './MLClaimDetailsPAInvolved.metadata.json5';
import messages from './MLClaimDetailsPAInvolved.messages';

function MLClaimDetailsPAInvolved(props) {
    const {
        insuredVehicleIncident,
        thirdPartyVehicleIncidents
    } = props;
    const translator = useTranslator();

    

    const shouldSectionBeVisible = () => {
        if(!insuredVehicleIncident){
            return false;
        }
        return !!(insuredVehicleIncident.owner_ML || insuredVehicleIncident.driver ||
            insuredVehicleIncident.passengers.length > 0 ||
            thirdPartyVehicleIncidents.find((incident) => incident.driver || incident.passengers.length > 0));
    };

    const getPrimaryAddress = (object) => {
        const address = object && object.primaryAddress;
        if (address) {
            return <>
                {address.addressLine1}
                <br />
                {`${address.city}, ${address.state} ${address.postalCode}`}
            </>
        }
    }

    const getPhoneNumber = (number, extension, parenIndicator) => {
        if (!number) { return ''; }
        number = String(number).replace(/[^0-9]+/g, '');

        const DELIMITER = '-';
        const US_PREFIX = '1';

        // Check for a possible prefix included and remove if so
        if (number.length === 11 && number[0] === US_PREFIX) {
            number = number.slice(1);
        }

        // If the length is not 10, the number format is wrong
        if (number.length !== 10) {
            return number;
        }

        const area = number.substring(0, 3);
        const front = number.substring(3, 6);
        const end = number.substring(6, 10);
        let formattedNumber;
        if (parenIndicator) {
            formattedNumber = `(${area}) ${front}${DELIMITER}${end}`;
        } else {
            formattedNumber = area + DELIMITER + front + DELIMITER + end;
        }
        let formattedExtension = '';
        if (extension) {
            const ext = String(extension).replace(/[^0-9]+/g, '');
            if (ext) {
                formattedExtension = ` ${translator(messages.ext)} ${ext}`;
            }
        }
        return formattedNumber.concat(formattedExtension);
    }

    const overrides = {
        PAInvolvedComponent: {
            visible: shouldSectionBeVisible()
        },
        insuredVehicleIncidentRow: {
            visible: !!insuredVehicleIncident
        },
        driverCol: {
            visible: !!insuredVehicleIncident?.owner_ML
        },
        driverColName: {
            content: insuredVehicleIncident?.owner_ML?.displayName
        },
        driverColAddress: {
            content: getPrimaryAddress(insuredVehicleIncident?.owner_ML)
        },
        driverColLicense: {
            visible: !!insuredVehicleIncident?.owner_ML?.licenseNumber_ML,
            content: <>{`${translator(messages.License)} ${insuredVehicleIncident?.owner_ML?.licenseNumber_ML}`}</>
        },
        driverColPhone: {
            visible: !!insuredVehicleIncident?.owner_ML?.contactNumber_ML,
            content: <>{`${translator(messages.Phone)} ${getPhoneNumber(insuredVehicleIncident?.owner_ML?.contactNumber_ML)}`}</>
        },
        yourDriverCol: {
            visible: !!insuredVehicleIncident?.driver
        },
        yourDriverColName: {
            content: insuredVehicleIncident?.driver?.displayName
        },
        yourDriverColAddress: {
            content: getPrimaryAddress(insuredVehicleIncident?.driver)
        },
        yourDriverColLicense: {
            visible: !!insuredVehicleIncident?.driver?.licenseNumber_ML,
            content: <>{`${translator(messages.License)} ${insuredVehicleIncident?.driver?.licenseNumber_ML}`}</>
        },
        yourDriverColPhone: {
            visible: !!insuredVehicleIncident?.driver?.emailAddress1,
            content: <>{`${translator(messages.Phone)} ${getPhoneNumber(insuredVehicleIncident?.driver?.contactNumber_ML)}`}</>
        },
        passengersIterable: {
            data: insuredVehicleIncident?.passengers || []
        }
    };
    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {
        },
        resolveCallbackMap: {
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLClaimDetailsPAInvolved;
